import { TOKEN, apiUrl } from "../Constants"
import api from "./ApiService"

const BASE_URL = apiUrl + "/api/excel-ec"

interface getECDataBody {
  site_ids: string[]
  job_ids: string[]
  ec_ids: string[]
}

// interface editECExportedStatusBody {
//   ec_ids: string[]
// }

export function getExcelECData(data: getECDataBody) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL}/get-excel-ec-data`, data, config)
}

export function getExcelECPagingData(data: getECDataBody) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL}/get-excel-ec/paging`, data, config)
}

export function getExcelECDataById(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.get(`${BASE_URL}/get-excel-ec/${data}`, config)
}

export function updateExcelECData(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.put(`${BASE_URL}/update-excel-ec`, data, config)
}

export function addExcelECData(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL}/add-user-ec`, data, config)
}

export function uploadCSVExceltoECExport(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL}/exportExcelECbyID`, data, config)
}

export function uploadStatus(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL}/update-status`, data, config)
}

export function getAllExcelECPagingData(data: getECDataBody) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }
  return api.post(`${BASE_URL}/get-all-ec-excel`, data, config)
}

export function updateStatusAllECData(data: any) {
  const config = {
    headers: { Authorization: `Bearer ${TOKEN}` },
  }

  return api.put(`${BASE_URL}/update-status-all-ec`, data, config)
}